import request from "helpers/api_helper";
import { toast } from "react-toastify";

export const getAllCustomers = async (queryString?: string) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `customers${queryString ? `?${queryString}` : ''}`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to fetch customers");
    return error;
  }
};

export const getCustomerById = async (id: number) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `customers/${id}`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to fetch customer");
    return error;
  }
};

export const updateCustomer = async (id: number, data: any) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `customers/${id}`,
      method: "PUT",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "Customer updated successfully");
    }
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to update customer");
    return error;
  }
};